<template>
  <v-container tag="section">
    <v-card id="conciliacao-tipos-concilicao" class="mx-auto v-card--wizard" elevation="12" max-width="700">
      <v-card-title class="display-2 font-weight-light justify-center pt-5" style="word-break: break-word">
        Selecione o tipo da sua conciliação
      </v-card-title>
      <v-card-text class="my-6">
        <general-card-item-group
          v-model="tipoConciliacao"
          :optionalId="true"
          :options="cardItemOptions"
          justify="center"
          @input="redirect($event)"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import tourMixins from '@/mixins/tourMixins';

  export default {
    components: {
      GeneralCardItemGroup: () => import('@/components/general/GeneralCardItemGroup')
    },

    mixins: [tourMixins],

    data: () => ({
      tipoConciliacao: '',
      arrTour: [
        {
          element: '#conciliacao-tipos-concilicao',
          intro: 'Inicialmente você deve escolher qual o tipo da sua conciliação.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#general-card-item-EXPRESS',
          intro: 'O primeiro tipo é a <i>Conciliação Express</i>, que é simplificada e de rápida configuração',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#general-card-item-CUSTOM',
          intro:
            'Já o segundo tipo é a <i>Conciliação Custom</i>, que permite mais customizações e possui configurações de nível avançado.',
          scrollTo: 'tooltip',
          position: 'right'
        }
      ],
      cardItemOptions: [
        {
          value: 'EXPRESS',
          text: 'Express',
          description: 'Conciliação simplificada e de rápida configuração.',
          icon: 'mdi-play-circle-outline'
        },
        { value: 'CUSTOM', text: 'Custom', description: 'Conciliação avançada e com mais configurações.', icon: 'mdi-target' }
      ]
    }),

    mounted() {
      this.iniciarTourPagina();
    },
    methods: {
      redirect(param) {
        const rota = 'edit/' + param.toLowerCase();
        this.$router.push({ path: rota });
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;
        this.iniciarTour(this.arrTour);
      }
    }
  };
</script>